/* global translation, dataLayer */

import {
  closestByClassName, findPrice, updatePrice,
} from './functions';

const maksimerReferralGetInvitedForm = () => {
  const referralInvitedPeople = document.getElementById('maksimer-referral-invited-people');
  if (referralInvitedPeople) {
    jQuery.post(translation.ajaxurl, { action: 'maksimer_referral_program_get_invited_table' }, (response) => {
      referralInvitedPeople.innerHTML = response;
    });
  }
};

if (document.body.classList.contains('woocommerce-account')) {
  if (document.body.classList.contains('woocommerce-view-subscription')) {
    Array.from(document.querySelectorAll('a.wcs-switch-link')).forEach((link) => {
      link.remove();
    });

    Array.from(document.querySelectorAll('table.order_details tbody .order_item .remove_item a')).forEach((link) => {
      link.remove();
    });
  }

  const optionalBundleProducts = Array.from(document.querySelectorAll('input[name*="add_to_order_product_qwdqwdqwqd"]'));
  if (optionalBundleProducts) {
    optionalBundleProducts.forEach((checkbox) => {
      // Fetch the table row
      const parentRow = closestByClassName(checkbox, 'order_item');

      const activePrice = parentRow.querySelector('td.active');

      // Get the price in the current row
      let price = 0;
      if (activePrice) {
        price = findPrice(activePrice);
      } else {
        price = findPrice(parentRow);
      }

      checkbox.addEventListener('change', () => {
        const totalPrices = Array.from(document.querySelectorAll('table.shop_table.order_details tfoot tr:not(.shipping)'));

        totalPrices.forEach((totalPrice) => {
          const currentTotal = findPrice(totalPrice);
          let newPrice = '';

          if (checkbox.checked) {
            newPrice = currentTotal + price;
          } else {
            newPrice = currentTotal - price;
          }

          updatePrice(totalPrice, newPrice);
        });
      });
    });
  }
}

const referralInvitePeopleForm = document.getElementById('maksimer-referral-invite-people');
if (referralInvitePeopleForm) {
  const noticeContainer = document.getElementById('maksimer-referral-notice-container');

  dataLayer.push({ event: 'referral_show' });

  referralInvitePeopleForm.addEventListener('submit', (event) => {
    event.preventDefault();

    dataLayer.push({ event: 'referral_submit' });

    const email = referralInvitePeopleForm.querySelector('input[name="email"]');
    const message = referralInvitePeopleForm.querySelector('textarea[name="message"]');
    const button = referralInvitePeopleForm.querySelector('button.button');
    const requestUri = referralInvitePeopleForm.querySelector('input[name="request_uri"]');

    referralInvitePeopleForm.style.cursor = 'wait';
    email.style.cursor = 'wait';
    message.style.cursor = 'wait';
    button.style.cursor = 'wait';
    button.style.pointerEvents = 'none';

    // The ajax request payload
    const payload = {
      action: 'maksimer_referral_program_invite_email',
      email: email.value,
      message: message.value,
      requestUri: requestUri.value,
    };

    jQuery.post(translation.ajaxurl, payload, (response) => {
      referralInvitePeopleForm.style.cursor = 'default';
      email.style.cursor = 'default';
      message.style.cursor = 'default';
      button.style.cursor = 'default';
      button.style.pointerEvents = 'auto';

      if (noticeContainer) {
        noticeContainer.innerHTML = response;
      }

      email.value = '';
      message.value = '';

      const isSuccess = noticeContainer.querySelector('.woocommerce-message');
      if (isSuccess) {
        const availableInvites = document.getElementById('available-invites');
        availableInvites.innerText -= 1;

        maksimerReferralGetInvitedForm();

        dataLayer.push({ event: 'referral_user_invited' });
      }
    });
  });
}

maksimerReferralGetInvitedForm();

// Add a send email function to all .mystore-unsub-button nodes
Array.from(document.getElementsByClassName('mystore-unsub-button')).forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();

    // Fetch  the subscription info from the node dataset
    const { subscription } = link.dataset;

    // Add loading to the link
    link.classList.add('wait');

    // This will trigger the ajax that is sending the email
    jQuery.post(translation.ajaxurl, { action: 'maksimer_mystore_send_unsub_email', subscription }, () => {
      const subscriptionStatus = jQuery(link).closest('tr').find('td.subscription-status');

      // Change the status of the current subscription to inactive
      if (subscriptionStatus) {
        subscriptionStatus[0].innerText = translation.inactive;
      }

      // In a timout to get the user to feel like something is happening
      setTimeout(() => {
        // Find the parent node
        const parent = link.parentNode;

        // Create a new element to display info about unsub
        const unsubMessage = document.createElement('p');
        unsubMessage.className = 'strong mystore-unsub-successful';
        unsubMessage.innerText = 'Takk, vi har mottatt din avmelding.';

        // Insert the info about unsub
        parent.insertBefore(unsubMessage, link);

        // Remove the link
        link.remove();
      }, 1000);
    });
  });
});

const passwordInputFields = Array.from(document.querySelectorAll('input[type=password]'));
if (passwordInputFields.length > 0) {
  passwordInputFields.forEach((passwordField) => {
    const wrapper = document.createElement('div');
    const checkbox = document.createElement('input');
    const random = Math.floor((Math.random() * 1000) + 1);
    const className = `pwid-${random}`;
    const pwField = passwordField.cloneNode(true);
    wrapper.classList.add('password-wrapper');

    checkbox.type = 'checkbox';
    checkbox.classList.add('toggle-password-view');
    checkbox.dataset.className = className;

    pwField.classList.add(className);

    passwordField.after(wrapper);
    wrapper.appendChild(pwField);
    wrapper.appendChild(checkbox);

    passwordField.remove();
  });

  setTimeout(() => {
    const passwordToggles = Array.from(document.querySelectorAll('input.toggle-password-view'));
    passwordToggles.forEach((pwToggle) => {
      pwToggle.addEventListener('change', () => {
        const { className } = pwToggle.dataset;
        const field = document.querySelector(`input.${className}`);
        if (field.type === 'password') {
          field.type = 'text';
        } else {
          field.type = 'password';
        }
      });
    });
  }, 100);
}
